import {
  INSIGHT_REPORT_LOADING,
  INSIGHT_REPORT_FINISHED_LOADING,
  INSIGHT_REPORT_FINISHED_LABEL,
  INSIGHT_REPORT_LOADING_LABEL,
  SET_GENERIC_REPORTS
} from '../mutation-types'

import {
  GET_INSIGHTS_REPORT,
  GET_GENERIC_REPORTS,
  GET_GENERIC_INSIGHTS_REPORT
} from '../action-types'

import axios from 'axios/index'
import FileSaver from 'file-saver'

const state = () => ({
  button_label: 'insights.download',
  report_loading: false,
  functions: {
    alertsReport: 'ALERT_RPT',
    userLogin: 'USRLOGRPT'
  },
  options: {
    enable: {
      alertsReport: 'ENBALTRPT',
      userLoginReport: 'ENBULRPT'
    }
  },
  generic_reports: []
})

const actions = {
  [GET_INSIGHTS_REPORT] ({commit, state, rootState}, {type, dateRange, filename}) {
    if (!state.report_loading) {
      commit(INSIGHT_REPORT_LOADING)
      commit(INSIGHT_REPORT_LOADING_LABEL)

      const actionData = { action: GET_INSIGHTS_REPORT, data: {type, dateRange, filename} }
      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/${type}/${dateRange.startDate}/${dateRange.endDate}`,
        method: 'get',
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        actionData,
        responseType: 'blob'
      }).then(res => {
        const name = `${filename} ${dateRange.startDate} - ${dateRange.endDate}.csv`
        FileSaver.saveAs(res.data, name)
        commit(INSIGHT_REPORT_FINISHED_LOADING)
        commit(INSIGHT_REPORT_FINISHED_LABEL)
      }).catch(err => {
        console.error(err)
        commit(INSIGHT_REPORT_FINISHED_LOADING)
        commit(INSIGHT_REPORT_FINISHED_LABEL)
      })
    }
  },
  [GET_GENERIC_REPORTS] ({rootState, state, commit}) {
    const actionData = { action: GET_GENERIC_REPORTS }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/generic/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(SET_GENERIC_REPORTS, res.data)
      })
      .catch((err) => {
        console.log('Failed to get generic reports')
        console.error(err)
      })
  },
  [GET_GENERIC_INSIGHTS_REPORT] ({commit, state, rootState}, {id, dateRange, filename}) {
    if (!state.report_loading) {
      commit(INSIGHT_REPORT_LOADING)
      commit(INSIGHT_REPORT_LOADING_LABEL)

      const actionData = { action: GET_GENERIC_INSIGHTS_REPORT, data: {id, dateRange, filename} }
      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/generic/${id}/${dateRange.startDate}/${dateRange.endDate}`,
        method: 'get',
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        actionData,
        responseType: 'blob'
      }).then(res => {
        const name = `${filename} ${dateRange.startDate} - ${dateRange.endDate}.csv`
        FileSaver.saveAs(res.data, name)
        commit(INSIGHT_REPORT_FINISHED_LOADING)
        commit(INSIGHT_REPORT_FINISHED_LABEL)
      }).catch(err => {
        console.error(err)
        commit(INSIGHT_REPORT_FINISHED_LOADING)
        commit(INSIGHT_REPORT_FINISHED_LABEL)
      })
    }
  }
}

const mutations = {
  [INSIGHT_REPORT_LOADING] (state) {
    state.report_loading = true
  },
  [INSIGHT_REPORT_FINISHED_LOADING] (state) {
    state.report_loading = false
  },
  [INSIGHT_REPORT_LOADING_LABEL] (state) {
    state.button_label = 'insights.download-in-progress'
  },
  [INSIGHT_REPORT_FINISHED_LABEL] (state) {
    state.button_label = 'insights.download'
  },
  [SET_GENERIC_REPORTS] (state, reports) {
    state.generic_reports = reports
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/insights.js